import DropdownList from '@/components/DropdownList';
import { JobRootSpecialtyV2, JobSearchGrade, JobSubSpeciality } from '@/types/jobs';
import { clearScrollWhenSearchCriteriaHasChanged } from '@/utils/jobSearchAutoScroll';
import cx from 'classnames';
import React, { ReactElement, useState } from 'react';

import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@material-ui/icons/KeyboardArrowUpOutlined';

import styles from './RoleFilterSection.module.scss';

export interface RoleFilterSectionProps {
  grade?: string;
  onGradeChange: (value: JobSearchGrade) => void;
  rootSpeciality?: string;
  onRootSpecialityChange: (value: JobRootSpecialtyV2) => void;
  subspeciality?: string;
  onSubSpecialityChange: (value: JobSubSpeciality) => void;
  getGradeOptions: () => ReactElement[];
  getRootSpecialityOptions: () => ReactElement[];
  getSubSpecialityOptions: () => ReactElement[];
}

const RoleFilterSection = ({
  grade,
  onGradeChange,
  rootSpeciality,
  onRootSpecialityChange,
  subspeciality,
  onSubSpecialityChange,
  getGradeOptions,
  getRootSpecialityOptions,
  getSubSpecialityOptions,
}: RoleFilterSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const summary = [grade, rootSpeciality].filter(Boolean).join(', ') || 'Any role';

  return (
    <div className={styles.container} data-testid="job-search-role-section">
      <button
        type="button"
        className={styles.header}
        onClick={() => setIsOpen(open => !open)}
        aria-expanded={isOpen}
        data-testid="job-search-role-toggle"
      >
        <span className={styles.header_labels}>
          <span className={styles.header_label}>Role</span>
          <span className={styles.header_valueRow}>
            <span className={styles.header_value}>{summary}</span>
            <span className={styles.header_icon}>
              {isOpen ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
            </span>
          </span>
        </span>
      </button>

      {isOpen && (
        <div className={styles.body}>
          <div className={cx(styles.field, styles.dropdownField)}>
            <DropdownList
              id="grade"
              label="Grade"
              value={grade}
              testId="job-search-grade-input"
              onChange={e => {
                onGradeChange(('' + e.target.value) as JobSearchGrade);
                clearScrollWhenSearchCriteriaHasChanged();
              }}
              renderOptions={getGradeOptions}
            />
          </div>

          <div className={cx(styles.field, styles.dropdownField)}>
            <DropdownList
              id="rootSpeciality"
              label="Speciality"
              value={rootSpeciality}
              testId="job-search-root-speciality-input"
              onChange={e => {
                onRootSpecialityChange(('' + e.target.value) as JobRootSpecialtyV2);
                clearScrollWhenSearchCriteriaHasChanged();
              }}
              renderOptions={getRootSpecialityOptions}
            />
          </div>

          <div className={cx(styles.field, styles.dropdownField)}>
            <DropdownList
              id="subspeciality"
              label="Subspeciality"
              value={subspeciality}
              testId="job-search-sub-speciality-input"
              onChange={e => {
                onSubSpecialityChange(('' + e.target.value) as JobSubSpeciality);
                clearScrollWhenSearchCriteriaHasChanged();
              }}
              renderOptions={getSubSpecialityOptions}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RoleFilterSection;
